<template>
	<div>
		<div class="goodsimg" @click="imgprev(goods_info.coverImage)"><img :src="goods_info.coverImage" width="100%" /></div>
		<div class="goodsinfo">
			<div class="goodstitle">{{goods_info.name}}</div>
			<div class="goodstag" v-if="goods_info.brief&&goods_info.brief.length>0">
				<div v-for="(items,indexs) in goods_info.brief" :key="indexs" class="tagitem">{{items}}</div>
			</div>
			<div class="goodsprice">
				<div v-if="showpromote" class="promoteprice" >{{(goods_info.product.discountPrice/100).toFixed(2)}}元</div>
				<div v-bind:class="{ delprice: showpromote}" v-if="goods_info.product" class="promoteprice">{{(goods_info.product.originalPrice/100).toFixed(2)}}元</div>
				<div class="promotetimercon" v-show="showpromote"><div class="promotetitle">限时优惠</div><van-count-down :time="promote_time" format="DD天HH时mm分ss秒" class="promotetimer"  /></div>
			</div>
		</div>
		<div class="goods_exinfo" v-if="goods_info.typeTags||goods_info.courseExt.curriculumTime||goods_info.courseExt.courseDuration||!trainContentEmpty">
			<div class="exinfocell" v-if="goods_info.typeTags">
				<div class="cellleft">授课方式</div>
				<div class="cellright">{{goods_info.typeTags}}</div>
			</div>
			<div class="exinfocell" v-if="goods_info.courseExt.curriculumTime">
				<div class="cellleft">开课时间</div>
				<div class="cellright">{{goods_info.courseExt.curriculumTime}}</div>
			</div>
			<div class="exinfocell" v-if="goods_info.courseExt.courseDuration">
				<div class="cellleft">课程时长</div>
				<div class="cellright">{{goods_info.courseExt.courseDuration}}</div>
			</div>
			<div class="exinfocell" v-if="!trainContentEmpty">
				<div class="cellleft">培训内容</div>
				<div class="cellright">{{goods_info.courseExt.trainContent}}</div>
			</div>
		</div>
		
		<div class="goodsbody">
			<van-tabs v-model="tactive" title-active-color="#ee0a24">
				
				  <van-tab title="详情">
					  <div class="goodscontent" v-html="goods_info.bewrite">
						  
					  </div>
				  </van-tab>
				  <van-tab :title="'目录('+treecount+')'" v-if="courseResourceTreeData.children&&courseResourceTreeData.children.length>0">
				  				  <ctree  v-for="(item,index) in courseResourceTreeData.children" :key="index" :treelist="item" @treeTap="coursetreeplay" :treelistindex="0"></ctree>
				  </van-tab>
			  <van-tab title="试听" v-if="courseResourceTreeTrySeeData.length>0">
			  	  <ctree  v-for="(item,index) in courseResourceTreeTrySeeData" :key="index" :treelist="item" @treeTap="shitingplay" :treelistindex="0"></ctree>
			  </van-tab>
			  
			  <van-tab title="资料" v-if="docfile_list.length>0">
				  <van-list
				    v-model="loading"
				    :finished="finished"
				    finished-text=""
				    @load="getdocfilelist"
				  >
				    <van-cell v-for="item in docfile_list" :key="item.materialId" :title="item.name" @click="detail(item)">
				      <template #right-icon>
				        <svg-icon icon-class="download" style="line-height: inherit;font-size:20px;color: #999999;"/>
				      </template>
				    </van-cell>
				  </van-list>
			  </van-tab>
<!-- 			  <van-tab title="师资力量">
				  <div class="goodscontent">
					  <img src="/img/shizi.jpg" width="100%"/>
				  </div>
				  </van-tab> -->
			</van-tabs>
		</div>
		<van-goods-action style="box-shadow: 0 -2px 6px #eee;">
		  <van-goods-action-icon icon="chat-o" text="客服" @click="phonecall" />
		  <van-goods-action-icon icon="shop-o" text="微官网" @click="back2home" />
			<van-goods-action-button :type="paybtntype" :color="paybtncolor" :text="paybtntext" style="border-radius: 999px;" @click="paygoods" ref="paygoodsbtn"/>
		</van-goods-action>
	</div>
</template>

<script>
	import { Toast } from 'vant';
	import { ImagePreview } from 'vant';
	import { Dialog } from 'vant';
	import wx from "weixin-js-sdk";
	import Utils from "../common/weixin";
	import ctree from '@/components/ctree.vue'
	import {CookieTool} from '@/utils/cookietool'
	import {api_base,api_goods,api_user} from '@/common/Request.js';
import { utils } from 'iscroll/build/iscroll-probe';
	
	export default {
		  data() {
		    return {
		      tactive: 0,
			  promote_time: 30 * 60 * 60 * 1000,
			  goods_id:0,
			  goods_info:'',
			  usertoken:'',
			  showpromote:false,
			  showshiting:false,
			  isvideoclass:true,
			  orderid:123,
			  coursepayed:false,
			  paybtntype:'danger',
			  paybtntext:'立即报名',
			  shitingcell:false,
			  courseResourceTreeData:'',
			  courseResourceTreeTrySeeData:[],
			  firstlive:'',
			  qd:'',
			  docfile_list:[],
			  finished: false,
			  loading:false,
			  paybtncolor:'',
			  trainContentEmpty:false,
			  treecount:0
		    };
		  },
	created(){
		if(!Utils.isIOS()){
			console.log("initwx");
			Utils.initWXConfig();
		}
		
	},
    mounted (){
    		this.goodsload();
    },
	  methods: {
		  imgprev(imgpath){
			  ImagePreview([imgpath]);
		  },
	    back2home() {
	      this.$router.push({
	        path: "/"
	      });
	    },
		phonecall(){
			window.location.href = 'tel://4008210721';
		},
		paygoods(){
			if(this.$cookies.isKey("user_token"))
			{
				
				if(!this.goods_info.hasBuy){
					if(this.goods_info.status==0){
						return alert('该商品已经下架，请返回首页购买其他课程或联系客服')
					}
				this.$router.push({
				  path: "payment",
				  query: { goodsid: this.goods_id }
				});
				}
				else{
					// Dialog.confirm({
					//   title: '注意',
					//   message:"您已购买该课程请不要重复购买，请点击课程表中的子课程进入学习！",
					// })
					//   .then(() => {
					//     // on confirm 
					// 	this.tactive=1;
					//   })
					//   .catch(() => {
					//     // on cancel
					// 	//Toast('操作已取消！')
					//   });
					
					//this.treefilterplay(this.courseResourceTreeData);
					this.findfirstliveplay(this.courseResourceTreeData.children);
					console.log("firstlive:",this.firstlive);
					if(this.firstlive!=''){
						this.coursetreeplay(this.firstlive);
					}
					else{
						this.treefilterplay(this.courseResourceTreeData.children);
					}
				}
			}
			else{
				Toast.fail("验证信息丢失，重新验证...");
				this.$router.push('/auth_new');
			}
			
			
			
		},
		promote_check(goodsinfo){
			if(goodsinfo.product.hasOwnProperty("discountPrice")){
				console.log(goodsinfo.product.discountPrice)
				if(goodsinfo.product.discountStartTime<new Date().getTime() && goodsinfo.product.discountEndTime>new Date().getTime()){
					this.showpromote=true;
					this.promote_time=(goodsinfo.product.discountEndTime-new Date().getTime());
				}
			}
		},
		typecheck(goods_type){
			if(goods_type==1){
				this.isvideoclass=true;
				this.shitingcheck();
			}
			else{
				this.isvideoclass=false;
			}
		},
		shitingcheck(){
			api_goods.goods_shiting(this.goods_id).then(res=>{
				console.log(res);
				if(res.code==0)
				{
					this.shitingcell=true;
				}
			});
		},
		shortcut_fun(goods_type)
		{
			if(this.$cookies.isKey("user_token"))
			{
				if(goods_type==1){
					this.usertoken=this.$cookies.get("user_token");
					api_user.my_video_detail(this.goods_id,this.usertoken).then(response => {
						console.log(response.data);
							if(response.code==0)
							{
								this.$router.push({ name: 'course_detail', query: { goodsid: this.goods_id }});
							}
					}
					)
					.catch(err=>{
						console.log(err);
					})
				}
				else if(goods_type==4)
				{
					this.usertoken=this.$cookies.get("user_token");
					api_user.my_live_detail(this.goods_id,this.usertoken).then(response => {
						console.log(response.data);
							if(response.code==0)
							{
								this.$router.push({ name: 'live_detail', query: { goodsid: this.goods_id }});
							}
					}
					)
					.catch(err=>{
						console.log(err);
					})
				}
				else if(goods_type==2){
					this.usertoken=this.$cookies.get("user_token");
					api_user.my_course_detail(this.goods_id,this.usertoken).then(response => {
						console.log(response.data);
							if(response.code==0)
							{
								this.coursepayed=true;
								this.paybtntext="已购买";
								this.paybtntype="default";
								Dialog.confirm({
								  title: '注意',
								  message: response.data,
								})
								  .then(() => {
								    // on confirm 
								  })
								  .catch(() => {
								    // on cancel
									//Toast('操作已取消！')
								  });
							}
					}
					)
					.catch(err=>{
						console.log(err);
					})
				}
			}
		},
		goodsload(){
			console.log(this.$route.fullPath);
			this.$cookies.set("beforeLoginUrl",this.$route.fullPath);
			
			this.qd = this.$route.query.qd
			if(this.qd&&this.qd!=""){
				CookieTool.setCookie("huazhi_qd",this.qd,30)
			}
			this.goods_id=this.$route.query.goodsid;
			if(this.goods_id>0){
				api_goods.goods_detail(this.goods_id).then(response => {
					this.goods_info = response.data;
					console.log(response.data);
					if(this.goods_info.coverImage==''){
						this.goods_info.coverImage="/img/default.jpg";
					}
					if(this.goods_info.hasBuy){
						this.paybtntext="开始学习";
					}
					else if(this.goods_info.status==0){
						this.paybtntext="已下架";
						this.paybtncolor="#bbbbbb"
						//this.paybtntype="default";
					}
					
					if(this.goods_info.brief != '' &&  this.goods_info.brief != null) {
					 this.goods_info.brief = (this.goods_info.brief).split(',')
					}
					
					if(this.$route.query.hasOwnProperty("activeid")){
						this.tactive=1;
					}
					document.title=this.goods_info.name;
					this.promote_check(this.goods_info);
					
					if(this.goods_info.hasOwnProperty("courseExt")==true && this.goods_info.courseExt) {
					    this.goods_info.courseExt = JSON.parse(this.goods_info.courseExt)
					}else {
					    this.goods_info.courseExt = {
					        trainContent: null,
					        curriculumTime: null,
					        courseDuration:null,
					        priceDetail: null
					    }
					}
					if(this.goods_info.courseExt.trainContent==null||this.goods_info.courseExt.trainContent==''){
						this.goods_info.courseExt.trainContent='我发现一门备考好课';
						this.trainContentEmpty=true;
					}
					
					let self = this;
					let shareconfig=new Object();
					shareconfig.title=this.goods_info.name;
					shareconfig.desc=this.goods_info.courseExt.trainContent;
					shareconfig.link=window.location.href;
					shareconfig.imgUrl='http://img.res.costoon.com/img/hz/56f093632c96491bb53cd453b6380911.png';
					console.log("initsharemenu");
					Utils.wxready(shareconfig);
					
					//初始化wx配置
					

					
					//this.typecheck(this.goods_info.goods_type);
					//this.shortcut_fun(this.goods_info.goods_type);
				})
				.catch(function(error){
					console.log(error);
				});
				this.courseResourceTreeListLoad();
				this.getdocfilelist();
			}
			else{
				Toast('商品id参数出错，请返回重试！');
			}
		},
		playshiting()
		{
			this.$router.push({
			  path: "shiting",
			  query: { goodsid: this.goods_id }
			});
		},
		coursetreeplay(data){
			console.log("play:",data);
			if(data.isLeaf){
				if(data.item.trySee==0){
				if(this.goods_info.hasBuy){
					if(data.item.resourceType==1&&data.item.lessonStatus<3){
						this.$router.push({
						  path: "live_detail",
						  query: { courseId: this.goods_id,
								   resourceId: data.item.resourceId
						   }
						});
					}
					else if(data.item.resourceType==1&&data.item.lessonStatus==3){
						this.$router.push({
						  path: "live_replay",
						  query: { courseId: this.goods_id,
								   resourceId: data.item.resourceId
						   }
						});
					}
					else if(data.item.resourceType==2){
						this.$router.push({
						  path: "course_detail",
						  query: { courseId: this.goods_id,
								   resourceId: data.item.resourceId
						   }
						});
					}
					else if(data.item.resourceType==9){
						Toast.fail('该课程为线下课程，请联系教务老师确定上课时间地点！');
					}
				}
				else{
					Toast.fail('请先购买课程！');
				}
				}
				else{
					if(data.item.resourceType==1&&data.item.lessonStatus<3){
						this.$router.push({
						  path: "live_detail",
						  query: { courseId: this.goods_id,
								   resourceId: data.item.resourceId
						   }
						});
					}
					else if(data.item.resourceType==1&&data.item.lessonStatus==3){
						this.$router.push({
						  path: "live_replay",
						  query: { courseId: this.goods_id,
								   resourceId: data.item.resourceId
						   }
						});
					}
					else if(data.item.resourceType==2){
						this.$router.push({
						  path: "course_detail",
						  query: { courseId: this.goods_id,
								   resourceId: data.item.resourceId
						   }
						});
					}
					else if(data.item.resourceType==9){
						Toast.fail('该课程为线下课程，请联系教务老师确定上课时间地点！');
					}
				}
			}
		},
		courseResourceTreeListLoad(){
			api_user.getCourseResourceTree(this.goods_id).then(res=>{
				console.log(res);
				const treedata=res.data.root;
				this.courseResourceTreeData=treedata;
				//this.treefilter(this.courseResourceTreeData);
				this.treefiltershiting(treedata.children);
				this.treefilterallcount(treedata.children);
				this.showshiting=true;
				console.log("treedata:",this.courseResourceTreeTrySeeData);
			})
		},
		// treefilter(treeNodes){
		// 	    if(!treeNodes||!treeNodes.length)return;
		// 	    for(let i=0;i<treeNodes.length;i++){
		// 	        let childs=treeNodes[i].children;
		// 			if(treeNodes[i].isLeaf){
		// 				let iconhtml="";
		// 				if(treeNodes[i].item.resourceType==1){
		// 					if(treeNodes[i].item.lessonStatus==3){
		// 						treeNodes[i].item.alias=treeNodes[i].item.alias+" ("+this.formattime("YYYY-mm-dd HH:MM",new Date(treeNodes[i].item.lessonStartTime))+" 课程回放)";
		// 					}
		// 					else if(treeNodes[i].item.lessonStatus==0){
		// 						treeNodes[i].item.alias=treeNodes[i].item.alias+" ("+this.formattime("YYYY-mm-dd HH:MM",new Date(treeNodes[i].item.lessonStartTime))+" 开始直播)";
		// 					}
		// 					else if(treeNodes[i].item.lessonStatus==1){
		// 						treeNodes[i].item.alias=treeNodes[i].item.alias+" (直播中)";
		// 					}
		// 					else if(treeNodes[i].item.lessonStatus==2){
		// 						treeNodes[i].item.alias=treeNodes[i].item.alias+" (直播完成待转码)";
		// 					}
		// 				}
		// 				else if(treeNodes[i].item.resourceType==2){ 
		// 					iconhtml="<i class='anticon anticon-play-circle-o'></i> ";
		// 				}
		// 				else if(treeNodes[i].item.resourceType==9){
		// 					iconhtml="<i class='anticon anticon-user'></i> ";
		// 				}
		// 				treeNodes[i].title=iconhtml+treeNodes[i].item.alias;
		// 				if(treeNodes[i].item.trySee=='1'){
		// 					this.courseResourceTreeTrySeeData.push(treeNodes[i]);
		// 				}
						
		// 			}
		// 			else{
		// 				treeNodes[i].title=treeNodes[i].item;
		// 				treeNodes[i].expanded=true;
		// 			}
		// 	        console.log(treeNodes[i])
		// 	        if(childs&&childs.length>0){
		// 	            this.treefilter(childs);
		// 	        }
		// 	    }
		// },
		treefilterplay(treeNodes){
			    if(!treeNodes||!treeNodes.length)return;
			    for(let i=0;i<treeNodes.length;i++){
			        let childs=treeNodes[i].children;
					if(treeNodes[i].isLeaf){
						if(treeNodes[i].item.resourceType==1){
							if(treeNodes[i].item.lessonStatus==3){
								this.$router.push({
								  path: "course_detail",
								  query: { courseId: this.goods_id,
										   resourceId: treeNodes[i].item.resourceId
								   }
								});
								break;
							}
							else if(treeNodes[i].item.lessonStatus==0){
								this.$router.push({
								  path: "live_replay",
								  query: { courseId: this.goods_id,
										   resourceId: treeNodes[i].item.resourceId
								   }
								});
								break;
							}
							else if(treeNodes[i].item.lessonStatus==1){
								this.$router.push({
								  path: "live_replay",
								  query: { courseId: this.goods_id,
										   resourceId: treeNodes[i].item.resourceId
								   }
								});
							}
						}
						else if(treeNodes[i].item.resourceType==2){
							this.$router.push({
							  path: "course_detail",
							  query: { courseId: this.goods_id,
									   resourceId: treeNodes[i].item.resourceId
							   }
							});
							break;
						}
						else if(treeNodes[i].item.resourceType==9){
							Toast.fail('该课程为线下课程，请联系教务老师确定上课时间地点！');
							break;
						}
						treeNodes[i].title=iconhtml+treeNodes[i].item.alias;
					}
			        console.log(treeNodes[i])
			        if(childs&&childs.length>0){
			            this.treefilterplay(childs);
			        }
			    }
		},
		formattime(fmt, date){
		        let ret;
		        const opt = {
		            "Y+": date.getFullYear().toString(),        // 年
		            "m+": (date.getMonth() + 1).toString(),     // 月
		            "d+": date.getDate().toString(),            // 日
		            "H+": date.getHours().toString(),           // 时
		            "M+": date.getMinutes().toString(),         // 分
		            "S+": date.getSeconds().toString()          // 秒
		            // 有其他格式化字符需求可以继续添加，必须转化成字符串
		        };
		        for (let k in opt) {
		            ret = new RegExp("(" + k + ")").exec(fmt);
		            if (ret) {
		                fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
		            };
		        };
		        return fmt;

	  },
	  shitingplay(data){
		  console.log("shitingplay:",data);
		  if(data){
			  if(data.isLeaf){
					if(data.item.resourceType==2){
						this.$router.push({
						  path: "shiting",
						  query: { courseId: this.goods_id,
								   resourceId: data.item.resourceId
						   }
						});
					}
					else if(data.item.resourceType==9){
						Toast.fail('该课程为线下课程，请联系教务老师确定上课时间地点！');
					}
			  }
		  }
		  
	  },
	  treefiltershiting(treeNodes){
	  	    if(!treeNodes||!treeNodes.length)return;
	  	    for(let i=0;i<treeNodes.length;i++){
	  	        let childs=treeNodes[i].children;
	  			if(treeNodes[i].isLeaf){
	  				if(treeNodes[i].item.trySee=='1'){
	  					this.courseResourceTreeTrySeeData.push(treeNodes[i]);
	  				}
	  			}
	  	        //console.log(treeNodes[i])
	  	        if(childs&&childs.length>0){
	  	            this.treefiltershiting(childs);
	  	        }
	  	    }
	  },
	  treefilterallcount(treeNodes){
	  	    if(!treeNodes||!treeNodes.length)return;
	  	    for(let i=0;i<treeNodes.length;i++){
	  	        let childs=treeNodes[i].children;
	  			if(treeNodes[i].isLeaf){
	  				this.treecount=this.treecount+1;
	  			}
	  	        if(childs&&childs.length>0){
	  	            this.treefilterallcount(childs);
	  	        }
	  	    }
	  },
	  findfirstliveplay(treeNodes){
		  if(!treeNodes||!treeNodes.length)return;
		  for(let i=0;i<treeNodes.length;i++){
		      let childs=treeNodes[i].children;
		  	if(treeNodes[i].isLeaf){
		  		if(treeNodes[i].item.resourceType=='1'&&treeNodes[i].item.lessonStatus==1){
					var ltime=new Date(treeNodes[i].item.lessonStartTime).toDateString();
					var ctime=new Date().toDateString()
					//console.log("lessonstarttime:",new Date(treeNodes[i].item.lessonStartTime).toDateString());
					//console.log("currenttime:",new Date().toDateString());
					if(ltime==ctime)
						this.firstlive=treeNodes[i];
						return;
		  		}
		  	}
		      //console.log(treeNodes[i])
		      if(childs&&childs.length>0){
		          this.findfirstliveplay(childs);
		      }
		  }
	  },
	  getdocfilelist(){
	  			//this.hotitemx="ok";
	  			//console.log(this.hotitemx);
	    //console.log('http://v.huazhi.cn/slim/app_v1/base/position_search/'+this.position_positiontype+'/null/null/null/'+this.position_specialtyexam+'/'+this.position_education+'/null/null/null/'+this.position_workyears+'/'+this.position_year+'/10/'+this.position_pageno);
	  		this.loading=true;
	  		api_user.getdocfile_list(this.goods_id).then(response => {
	  			console.log(response.data);
	  			const list =response.data;
	        this.docfile_list = [...this.docfile_list,...list];
	  			
	  			this.loading=false;
	  			this.finished=true;
	  			})
	  			.catch(err=>{
	  				console.log(err);
	  				})
	  		},
	  detail(item){
				if(this.goods_info.hasBuy){
					api_user.downloadMaterial(this.goods_id,item.lessonId,item.materialId).then(res=>{
						//window.open(res.data);
						window.location.href=res.data;
					})
				}
				else{
					Toast.fail('请先购买课程再下载资料！');
				}
	  		}
	},
	components: {
	ctree
	}
};
</script>

<style lang="scss" scoped>
	.promoteprice{
		font-size:15px;
	}
	
	.promotetimercon{
		display: flex;
		flex-direction: row;
		margin-left: 1.25rem;
		border: solid 1px #FC4850;
		font-size: 10px;
		align-items: center;
	}
	
	.promotetitle{
		color:white;
		background-color: #FC4850;
		padding-left: 5px;
		padding-right:5px;
		height: 100%;
		display: flex;
		align-items: center;
	}
			
	.goodsinfo{
		position: relative;
		padding-left: 1.25rem;
		padding-right: 1.25rem;
		padding-top:10px;
		padding-bottom: 10px;
		.goodstitle{
			color:#333333;
			overflow: hidden;
			font-weight: bolder;
			font-size:16px;
			padding-bottom: 8px;
		}
		.goodstag{
			font-size:12px;
			color:#999;
			padding-bottom:8px;
			// margin: 0 0 0.625rem 0;
			display: flex;
			flex-direction: row;
			.tagitem{
				flex:0 auto;
				text-align: center;
				background: #fff3f3;
				border-radius: 2px;
				margin-right: 0.625rem;
				color:#FF5249;
				padding:0.1875rem 0.625rem;
			}
		}
		.goodsprice{
			color: #FC4850;
			bottom: 0.4rem;
			display: flex;
			flex-direction: row;
		}
	}

	.delprice{
		text-decoration:line-through;
		color:#ccc;
		padding-left: 10px;
	}
	
	.goods_exinfo{
		background-color: #fff;
		border-top: solid 0.625rem #f2f4f5;
		padding: 0.3125rem 1.25rem;
		.exinfocell{
			margin: 0.625rem 0;
			display: flex;
			flex-direction: row;
			.cellleft{
				flex:1 6.25rem;
				width: 6.25rem;
				color:#999;
			}
			.cellright{
				flex:0 auto;
				width:100%;
			}
		}
	}
	
	.promotetimer{
		text-align: center;
		font-size: 10px;
		color:#FC4850;
		padding-left:5px;
		padding-right:5px;
		//background-image: linear-gradient(#FC4850, #fc8c92);
	}
	.goodsbody{
		border-top: solid 0.625rem #f2f4f5;
		margin: 0;
		padding-bottom:10rem;
		.goodscontent{
			margin: 1.25rem 1.25rem 0 1.25rem;
			overflow: hidden;
		}
	}
	
	::v-deep .goodscontent img{
		width:100%;
	}
	
	.ant-tree{
	  padding-left: 0.5rem !important;
	}
	
	::v-deep .ant-tree li  .ant-tree-node-content-wrapper{
	  white-space: normal !important;
	  max-width: 85%;
	}
</style>
